exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topic-detail-box .topic-image {\n    width: 100%;\n    max-height: 150px;\n}\n.topic-detail-box {\n    border: 1px solid #cecece;\n    background-color: #fff;\n    margin-bottom: 8px;\n    padding: 20px 30px;\n    float: left;\n    width: 100%;\n}\n.topic-detail-box h3 {\n    text-align: left;\n    font-size: 23px;\n\n}\n.topic-description {\n    font-size: 14px;\n    color: #828282;\n    margin: 5px 0;\n}\n.client-social-button-outer-box-left ul li a {\n    color: #828282;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/topicdetail/topicdetail.component.css
// module id = ../../../../../src/app/home/topicdetail/topicdetail.component.css
// module chunks = common